import React, { useState } from 'react';
import {getLogger} from '@ignitesales/logger-es';
import {formatPhoneNumberField} from '../utils/helpers/formatHelper';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import FormContainer from './Forms/FormContainer';
import FormInput from './Forms/FormInput';
import NeuroMessage from './NeuroMessage';
import { triggerIgniteAction, sendResultsViaSms, useDispatch } from '../state';

const logger = getLogger({ module: 'ShareViaSmsForm' });

const ShareViaSmsForm = ({ className, initialValue = null, onSubmit }) => {
  const dispatch = useDispatch();
  const formId = 'shareViaSms';
  const classes = classnames(className, 'socialForm', 'shareViaSmsForm');
  const [phoneNumber, setPhoneNumber] = useState(initialValue);

  const onChange = ({ value }) => {
    setPhoneNumber(value);
  };

  const onFormSubmit = () => {
    const formattedNumber = formatPhoneNumberField(phoneNumber);
    logger.debug('ShareViaSmsForm phone number submitted', formattedNumber);
    dispatch(triggerIgniteAction({ actionName: 'shareViaSmsClicked' }));
    dispatch(sendResultsViaSms(formattedNumber));
    onSubmit && onSubmit(formattedNumber);
  };

  return (
    <section className={classes}>
      <NeuroMessage id="shareViaSms.formBody" tagName="p" />
      <FormContainer onSubmit={onFormSubmit} formId={formId} renderDefaultSubmit={true}>
        <FormInput
          formId={formId}
          initialValue={initialValue}
          name="phoneNumber"
          required={true}
          isPhoneNumber={true}
          onChange={onChange}
        />
      </FormContainer>
    </section>
  );
};
ShareViaSmsForm.propTypes = {
  className: PropTypes.string,
  initialValue: PropTypes.string,
  onSubmit: PropTypes.func,
};

export default ShareViaSmsForm;
